import { PropertyGroup } from "../property-group";
import { armorGroup } from "./armor/armor-group";
import { weaponGroup } from "./weapon/weapon-group";
import { miscGroup } from "./misc/misc-group";

export const equipmentGroup = new PropertyGroup("Equipment", [...weaponGroup.group, ...miscGroup.group, ...armorGroup.group])
